<template>
    <div class="betslip betslip-preview betslip--offline">
        <div class="betslip-header betslip__static__top betslip-header--offline">
            <div class="betslip-header__title">
                <span v-if="isLotto">{{ $t('lotto') | capitalize }}</span>
                <span v-else-if="isRetailVirtual">{{ $t('virtual') | capitalize }}</span>
                <span v-else-if="isRetailLive">{{ $t('sport') | capitalize }} │ {{ $t('simple') | capitalize }}</span>
                <span v-else-if="isSportSystem">{{ $t('sport') | capitalize }} │ {{ $t('system') | capitalize }}</span>
                <span v-else>{{ $t('sport') | capitalize }} │ {{ $t('simple') | capitalize }}</span>
            </div>
            <i
                @click="$emit('close')"
                class="icon icon-close"
            ></i>
        </div>
        <Toolbar
            :selectionsCount="ticket.events.length"
            :selectionNames="isLotto ? $t('numbers') : $t('events')"
            :isOfflineTicket="true"
            :totalCoefficient="ticket.coefficient ? twoDecimals(ticket.coefficient) : 'N/A'"
            @close="$emit('close')"
        />
        <div class="betslip-body" >
            <div class="betslip-body__side">
                <OfflineLottoTicket
                    v-if="isLotto"
                    :events="ticket.events"
                />
                <OfflineVirtualTickets
                    v-else-if="isRetailVirtual"
                    :events="ticket.events"
                />
                <OfflineSportTicket
                    v-else
                    :events="ticket.events"
                />
            </div>
            <div class="betslip-body__side betslip__static__bottom">
                <div class="preview-message-area">
                    <div
                        v-if="!isSubmit"
                        class="betslip__status"
                    >
                        <Illustration
                            large
                            :image="'/static/img/illustrations/betslip__status-' + status + '.svg'"
                            class="betslip__status-illustration"
                        />
                        <div
                            :class="status"
                            class="betslip__status-outcome"
                        >
                            {{ $t('ticket') | capitalize }} {{ $t(status) | capitalize }}
                        </div>
                    </div>
                    <div class="betslip-offline__details">
                        <Barcode
                            v-if="isSubmit"
                            :text="ticket.id"
                            :height="16"
                            class="betslip-offline__details-barcode"
                        />
                        <div class="betslip-offline__details-ticketID">
                            {{ ticket.id }}
                        </div>
                    </div>
                </div>
                <div class="betslip__details betslip__details--offline">
                    <div
                        v-if="ticket.coefficient"
                        class="betslip-stake__row betslip-stake__total-quota"
                    >
                        <div class="betslip-stake__total-quota-label">
                            {{ $t('total quota') | capitalize }}:
                        </div>
                        <div
                            class="betslip-stake__total-quota-number"
                            :title="ticket.coefficient"
                        >
                            {{ ticket.coefficient | twoDecimals }}
                        </div>
                    </div>
                    <div
                        v-if="isSportSystem || isLottoSystem"
                        class="betslip-system__row"
                    >
                        <div class="betslip-system__label">{{ $t('system') | capitalize }}</div>
                        <div class="betslip-system__type">{{ systems }}</div>
                    </div>
                    <div
                        v-if="hasReducedStake && typeof ticket.payment.stake === 'number'"
                        class="betslip-offline-stake__row"
                    >
                        <div
                            v-if="Number.isFinite(ticket.payment.stake)"
                            class="betslip-offline-stake__amount-wrapper"
                        >
                            <div class="betslip-offline-stake__amount-label">
                                {{ $t('stake after tax') | capitalize }}:
                            </div>
                            <div class="betslip-offline-stake__amount">
                                {{ ticket.payment.stake | twoDecimals }}
                                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="hasReducedStake && typeof ticket.payment.handlingFee === 'number'"
                        class="betslip-offline-stake__row"
                    >
                        <div class="betslip-offline-stake__amount-wrapper">
                            <div class="betslip-offline-stake__amount-label">
                                {{ $t('tax') | capitalize }}:
                            </div>
                            <div class="betslip-offline-stake__amount">
                                {{ ticket.payment.handlingFee | twoDecimals }}
                                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="betslip-offline-stake__row">
                        <div class="betslip-offline-stake__amount-wrapper">
                            <div class="betslip-offline-stake__amount-label">{{ $t('stake') | capitalize }}:</div>
                            <div class="betslip-offline-stake__amount">
                                {{ ticket.payment.total | twoDecimals }}
                                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="(isSportSystem || isLotto) && ticket.win.minPotential"
                        class="betslip-offline-stake__row"
                    >
                        <div class="betslip-offline-stake__amount-wrapper">
                            <div class="betslip-offline-stake__amount-label">
                                {{ $t('minimum potential win') | capitalize }}
                            </div>
                            <div class="betslip-offline-stake__amount">
                                {{ this.ticket.win.minPotential | twoDecimals }}
                                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="betslip__static-content betslip__static-content--offline">
                    <!--TODO coefficient is really combinations-->
                    <div class="betslip__potential-gain">
                        <div class="betslip-offline__potential-gain-simple">
                            <span class="betslip__potential-gain-label">
                                {{ $t(payoutText) | capitalize }}
                            </span>
                            <span class="betslip__potential-gain-amount">
                                {{ payout | twoDecimals }}
                                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
                            </span>
                        </div>
                    </div>
                    <div
                        v-if="bonus"
                        class="betslip__potential-gain"
                    >
                        <div class="betslip-offline__potential-gain-simple">
                            <span class="betslip__potential-gain-label">
                                {{ $t('bonus') | capitalize }}
                            </span>
                            <span class="betslip__potential-gain-amount">
                                {{ bonus | twoDecimals }}
                                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
                            </span>
                        </div>
                    </div>
                    <div
                        v-if="!isPrintable"
                        class="betslip__actions"
                    >
                        <CustomButton
                            @click="$emit('close')"
                            class="betslip__button betslip__button--close"
                        >
                            {{ $t('close') | capitalize }}
                        </CustomButton>
                        <CustomButton
                            v-if="isDesktop"
                            @click="onPrintTicket"
                            class="betslip__button"
                        >
                            {{ $t('print') | capitalize }}
                        </CustomButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { twoDecimals } from '@shared/filters';
    import { TicketType, TicketStatus } from '@models/tickets/enums';
    import Toolbar from '@shared/betSlip/Toolbar';
    import { printPage } from '@app/utils/browserAPI';
    import { isDesktop } from '@core/utils/userAgent/UAUtils';
    import OfflineSportTicket from './OfflineSportTicket';
    import OfflineLottoTicket from './OfflineLottoTicket';
    import OfflineVirtualTickets from './OfflineVirtualTickets';

    export default {
        props: {
            ticket: {
                type: Object,
                required: true,
            },
            isSubmit: {
                type: Boolean,
                required: false,
                default: false,
            },
            isPrintable: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        created() {
            this.twoDecimals = twoDecimals;
        },
        mounted() {
            this.$emit('rendered');
        },
        computed: {
            isLotto() {
                return this.ticket.type.toLowerCase() === TicketType.lotto;
            },
            isRetailLive() {
                return this.isRetail && this.ticket.id.startsWith('X1');
            },
            isRetailVirtual() {
                return this.isRetail && !this.isRetailLive;
            },
            isRetail() {
                return ![
                    TicketType.lotto,
                    TicketType.sport,
                ].includes(this.ticket.type.toLowerCase());
            },
            isSportSystem() {
                return !this.isLotto && !!this.ticket.system;
            },
            isLottoSystem() {
                return this.isLotto && !!this.ticket.system;
            },
            systems() {
                if (!this.ticket.system) {
                    return '';
                }
                return `${this.ticket.system.selected.join(',')}/${this.ticket.system.count}`;
            },
            bonus() {
                return this.ticket.bonus && this.ticket.bonus.value;
            },
            status() {
                switch (this.ticket.status) {
                    case TicketStatus.active:
                        return 'active';
                    case TicketStatus.win:
                        return 'won';
                    case TicketStatus.lost:
                        return 'lost';
                    case TicketStatus.canceled:
                        return 'canceled';
                    case TicketStatus.refund:
                        return 'refunded';
                    case TicketStatus.obsolete:
                        return 'obsolete';
                    case TicketStatus.payed:
                        return 'payed';
                    default:
                        return '';
                }
            },
            isWon() {
                return this.ticket.status === TicketStatus.win;
            },
            payoutText() {
                return this.isWon ? 'payout' : 'potential win';
            },
            payout() {
                return this.isWon ? this.ticket.win.payoff : this.ticket.win.estimated;
            },
            hasReducedStake() {
                const { stake, total } = this.ticket.payment;
                return stake < total;
            },
            isDesktop() {
                return isDesktop();
            }
        },
        methods: {
            ...mapActions('ui/modal', [
                'closeAllModals',
            ]),
            async onPrintTicket() {
                await printPage();
                this.closeAllModals();
            }
        },
        components: {
            OfflineSportTicket,
            OfflineLottoTicket,
            OfflineVirtualTickets,
            Toolbar
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/tickets/OfflineTicket.vue